import React, { useContext } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { spacing } from "../../../../../../stitches.config";
import { FlexColumn } from "../../../../../Common/__styles__/Layout";
import { Button } from "../../../../../Common/Buttons/Button";
import { ParcelImportWizardContext } from "../context";
import { AdditionalImportFieldRow } from "../ImportFieldRows";
import {
  PARCEL_IMPORT_CONFIG_WORKFLOW,
  ParcelImportWizardFormData,
} from "../types";
import { makeAdditionalFieldConfig } from "../utils";

const AdditionalFieldsSection = () => {
  const { workflow } = useContext(ParcelImportWizardContext);
  const { control } = useFormContext<ParcelImportWizardFormData>();
  const {
    fields: additionalFields,
    append,
    remove,
  } = useFieldArray<ParcelImportWizardFormData>({
    control,
    name: "additionalFields",
  });

  return (
    <FlexColumn style={{ gap: spacing.l.value }}>
      {additionalFields.map((field, fieldIndex) => {
        const fieldConfig = makeAdditionalFieldConfig();

        return (
          <AdditionalImportFieldRow
            key={field.id}
            fieldConfig={fieldConfig}
            fieldIndex={fieldIndex}
            removeField={remove}
          />
        );
      })}
      {workflow === PARCEL_IMPORT_CONFIG_WORKFLOW.CREATE && (
        <span>
          <Button
            variant="secondary"
            onPress={() =>
              append({
                label: "",
                source: "",
                displayName: "",
                isPublic: false,
              })
            }
            size="medium"
            iconStart="plus"
            title="Additional field"
          />
        </span>
      )}
    </FlexColumn>
  );
};

export default AdditionalFieldsSection;
